export const notifications = '/custom-notifications';
export const notification = (id: number) => `/custom-notifications/${id}`;
export const sendNotification = (id: number) => `/custom-notifications/send/${id}`;
